import styled from 'styled-components';
import { StyledModalStepper } from '../styles';

export const PartnerOnboradingWrapper = styled(StyledModalStepper)`
    .employee-rights, .terms-and-conditions {        
        margin-left: -10px;
    }
   .mdc-text-field--outlined:not(.mdc-text-field--disabled),
   .mdc-select--outlined:not(.mdc-select--disabled) {
        background: ${({ theme }) => theme.whiteText};
   }
`;

export const StyledProfile = styled.div`
    border-top: 1px solid ${({ theme }) => theme.tableBorderColor};
    .mdc-menu-surface--anchor {
        font-size: ${({ theme }) => theme.fontSizes.fs14};
        &:not(:first-child) {
            margin-left: -15px;
        }
    }
`;
